// 店家 LINE 聯絡連結：店家填的 LINE 可能是三種寫法，各自用對應的加好友網址
//  1. 加好友網址（lin.ee/… 或 line.me/…）→ 直接用（舊資料可能被誤加 @，先去掉）
//  2. 官方帳號 ID（@ 開頭，例 @382cumwc）→ https://line.me/R/ti/p/@ID
//  3. 個人 LINE ID（沒有 @，例 uu930429）→ https://line.me/ti/p/~ID
export function storeLineUrl(raw) {
  const v = String(raw || '').trim()
  if (!v) return ''
  const url = v.replace(/^@+/, '')
  if (/^(https?:\/\/)?(lin\.ee|line\.me|page\.line\.me)\//i.test(url)) {
    return /^https?:\/\//i.test(url) ? url : 'https://' + url
  }
  if (v.startsWith('@')) return `https://line.me/R/ti/p/@${encodeURIComponent(v.slice(1))}`
  return `https://line.me/ti/p/~${encodeURIComponent(v)}`
}

// 店家儲存 LINE 時的整理：保留店家原本的寫法（個人 ID 不自動加 @），只去掉網址前誤加的 @
export function normalizeStoreLineId(raw) {
  const v = String(raw || '').trim()
  if (!v) return ''
  return /^@+(https?:\/\/|lin\.ee|line\.me)/i.test(v) ? v.replace(/^@+/, '') : v
}
